<div class="main-section">
  <div class="top-section">
    <div class="icon-circle">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d92d20" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
      </svg>
    </div>
    <div class="popup-profile-name">Exit?</div>
  </div>
  <div class="light-text">Any unsaved changes will be discarded. This cannot be undone.</div>
  <div class="button-section">
    <button class="sec-btn" (click)="cancel()">Go Back</button>
    <button class="btn-name" (click)="back()">Yes, Exit</button>
  </div>
</div>

